import styled from 'styled-components';

export const SettingCard = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 24px 32px;
  border-bottom: 1px solid #acacac;
`;
